import { Box } from '@factorialco/deprecated-design-system'
import { TrainingsCatalogPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'

import PageLoading from 'modules/layout/components/Page/Loading'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { CatalogComponent } from 'modules/trainings/components/CatalogComponent'
import { Provider } from 'modules/trainings/components/CatalogComponent/Provider'
import { useCompetencies } from 'modules/trainings/hooks/Trainings/useCompetencies'

const Catalog = () => {
  const { search, onSearch } = useDebouncedSearch()
  const { loading: loadingCompetencies, competencies } = useCompetencies()
  const { loading: loadingPermissions, data } = useQuery(TrainingsCatalogPageDocument)
  const categories = data ? data.trainings.categories : undefined
  // This needs to be here because the provider use the competencies mobx collection
  // TODO: refactor the datatable so it contains the competencies in the same query
  if (loadingCompetencies || loadingPermissions) {
    return (
      <Box width="full" height="full" justifyContent="center">
        <ResponsivePage.Body variant="wide" showHeader={false}>
          <PageLoading />
        </ResponsivePage.Body>
      </Box>
    )
  }

  if (
    (!data?.trainings._policies.trainingsSeeCatalog.can ||
      !data?.trainings._policies.trainingsRequestsCreate.can) &&
    !data?.trainings._policies.trainingsAccessManagementSpace.can
  )
    return <NotFound />

  const isEmpty = data.trainings.trainingsConnection.totalCount === 0

  return (
    <Provider categories={categories} search={search} competencies={competencies}>
      <CatalogComponent
        search={search}
        onSearch={onSearch}
        accessManagementSpace={data?.trainings._policies.trainingsAccessManagementSpace.can}
        isEmpty={isEmpty}
      />
    </Provider>
  )
}

export default Catalog
